import { workspaceOwnsBilling } from "@helpers/billingOwnership";
import { useActiveWorkspaceDetails } from "@hooks/useActiveWorkspaceDetails";
import { UserWorkspaceRole } from "@common/userWorkspaceRoles";
import { useActiveWorkspaceAssigment } from "./useActiveWorkspaceAssignment";

export function useCanRequestBillingTransfer() {
    const activeWorkspaceDetails = useActiveWorkspaceDetails();
    const activeWorkspaceAssignment = useActiveWorkspaceAssigment();

    if (!activeWorkspaceDetails || !activeWorkspaceAssignment) {
        return false;
    }

    if (workspaceOwnsBilling(activeWorkspaceDetails)) {
        return false;
    }

    return (
        activeWorkspaceAssignment.role === UserWorkspaceRole.ADMIN &&
        !activeWorkspaceAssignment.organizationId
    );
}
